module.exports = __webpack_public_path__ + "img/motorbikeTop.22160788.svg";